import moment from 'moment'
import React from 'react'
import { COLORS } from 'theme'

import {
  MainHeading,
  OtherFlex,
  SecondGreyText,
  SubFLex,
  StyledP
} from 'modules/Students/Partials/StudentsInfoTable/ViewStudentDrawer/Partials/StudentDrawerContent/Style/style'

const OtherDetails = ({ studentData }) => {
  const otherData = [
    {
      id: 1,
      name: 'Preferred Location',
      value: studentData?.studentPersonalProfile?.isAnywhere
        ? 'Anywhere'
        : studentData?.studentPersonalProfile?.preferredJobLocation?.toString(),
    },
    {
      id: 2,
      name: 'Gender',
      value:
        studentData?.admin?.gender ||
        studentData?.studentPersonalProfile?.gender,
    },
    {
      id: 3,
      name: 'Registration No.',
      value: studentData?.uniRollNo,
    },
    {
      id: 4,
      name: 'Date of Birth',
      value: studentData?.studentPersonalProfile?.dob
        ? moment(studentData?.studentPersonalProfile?.dob).format(
            'DD/MM/YYYY'
          ) != 'Invalid date'
          ? moment(studentData?.studentPersonalProfile?.dob).format(
              'DD/MM/YYYY'
            )
          : ''
        : '',
    },
    {
      id: 5,
      name: 'Secondary Email ID',
      value: studentData?.studentPersonalProfile?.secondaryEmail,
    },
    {
      id: 6,
      name: 'Caste',
      value: studentData?.studentPersonalProfile?.caste,
    },
    {
      id: 7,
      name: 'Religion',
      value: studentData?.studentPersonalProfile?.religion,
    },
    {
      id: 8,
      name: 'Language',
      value: studentData?.studentPersonalProfile?.languages?.toString(),
    },
    {
      id: 9,
      name: 'Hobbies',
      value: studentData?.studentPersonalProfile?.hobbies?.toString(),
    },
    {
      id: 10,
      name: 'Temporary Address',
      value:
        (studentData?.studentPersonalProfile?.corrAddrLine1
          ? studentData?.studentPersonalProfile?.corrAddrLine1 + ','
          : '') +
        (studentData?.studentPersonalProfile?.corrAddrLine2
          ? studentData?.studentPersonalProfile?.corrAddrLine2 + ','
          : '') +
        (studentData?.studentPersonalProfile?.corrCity
          ? studentData?.studentPersonalProfile?.corrCity + ','
          : '') +
        (studentData?.studentPersonalProfile?.corrState
          ? studentData?.studentPersonalProfile?.corrState + ','
          : '') +
        (studentData?.studentPersonalProfile?.corrCountry
          ? studentData?.studentPersonalProfile?.corrCountry + ','
          : '') +
        (studentData?.studentPersonalProfile?.corrPostCode
          ? studentData?.studentPersonalProfile?.corrPostCode
          : ''),
    },
    {
      id: 11,
      name: 'Permanent Address',
      value:
        (studentData?.studentPersonalProfile?.permAddrLine1
          ? studentData?.studentPersonalProfile?.permAddrLine1 + ','
          : '') +
        (studentData?.studentPersonalProfile?.permAddrLine2
          ? studentData?.studentPersonalProfile?.permAddrLine2 + ','
          : '') +
        (studentData?.studentPersonalProfile?.permCity
          ? studentData?.studentPersonalProfile?.permCity + ','
          : '') +
        (studentData?.studentPersonalProfile?.permState
          ? studentData?.studentPersonalProfile?.permState + ','
          : '') +
        (studentData?.studentPersonalProfile?.permCountry
          ? studentData?.studentPersonalProfile?.permCountry + ','
          : '') +
        (studentData?.studentPersonalProfile?.permPostCode
          ? studentData?.studentPersonalProfile?.permPostCode
          : ''),
    },
  ]
  return (
    <>
      <MainHeading>Other Information</MainHeading>
      <SubFLex column gap="20px">
        {otherData?.map((item, index) => (
          <SubFLex key={index + 'dataInformation'}>
            <OtherFlex spaceBetween>
              <SecondGreyText color={COLORS.GREY_T_60}>
                {item?.name}
              </SecondGreyText>
              <SecondGreyText>-</SecondGreyText>
            </OtherFlex>
            <OtherFlex width="65%">
              <SecondGreyText>{item?.value}</SecondGreyText>
            </OtherFlex>
          </SubFLex>
        ))}
      </SubFLex>

      {studentData?.studentPersonalProfile?.extraCurriculars && (
        <>
        <MainHeading marginBottom={'10px'}>ExtraCurricular Activities</MainHeading>
  <StyledP
    dangerouslySetInnerHTML={{
      __html: studentData?.studentPersonalProfile?.extraCurriculars,
    }}
  />
  </>
)}
    </>


  )
}

export default OtherDetails
